// import React from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import React, { Component } from "react";
import "slick-carousel/slick/slick-theme.css";
import Image1 from "../styles/images/banner1.png";
import Image2 from "../styles/images/banner2.png";
import Image3 from "../styles/images/banner3.png";
import Business from "../styles/images/slack.svg";
import styles from './scss/slacklanding.module.scss';
import LeftArrow from "../styles/images/leftgrey.svg";
import RightArrow from "../styles/images/rightgrey.svg";
import GetStarted from "./get-started";
import Footer from "./footer/footer";
function SlackPage() {

    const SlackAuth = () => {
        /*window.open("https://slack.com/oauth/v2/authorize?client_id=4854286449888.4828600015126&scope=commands,im:history,users:read&redirect_uri=https://marketplace.worktual.co.uk/waitingPage")*/
        window.open("https://slack.com/oauth/v2/authorize?client_id=4854286449888.4828600015126&scope=commands,users:read&redirect_uri=https://marketplace.worktual.co.uk/waitingPage")
    }
    // const SlickArrowLeft = ({ currentSlide, slideCount, ...props }) => (
    //     <img
    //         src={}
    //         {...props}
    //         className={
    //             "slick-prev slick-arrow" +
    //             (currentSlide === 0 ? " slick-disabled" : "")
    //         }
    //         aria-hidden="true"
    //         aria-disabled={currentSlide === 0 ? true : false}
    //     />

    // );
    // const SlickArrowRight = ({ currentSlide, slideCount, ...props }) => (
    //     <img
    //         src={`${basePath}rightWhite.svg`}
    //         {...props}
    //         className={
    //             "slick-next slick-arrow" +
    //             (currentSlide === slideCount - 1 ? " slick-disabled" : "")
    //         }
    //         aria-hidden="true"
    //         aria-disabled={currentSlide === slideCount - 1 ? true : false}
    //         type="button"
    //     />
    // );
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: <img src={LeftArrow} />,
        prevArrow: <img src={RightArrow} />
    };
    const settingsBlack = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        // prevArrow: <SlickArrowLeft />,
        // nextArrow: <SlickArrowRight />,
    };
    return (
        <>
            <div className={`${styles.stackmainconsec} testimonialSlider`}>
                <div className={`${styles.mobilpadnone} ${styles.containers}`}>
                    <div className={styles.spanClass}>
                        <div className={styles.leftimg}>
                            <img src={Business} alt="" />
                            {/* <span className={styles.boxes}>Farhath</span> */}
                        </div>
                        <div className={styles.rightconsec}>
                            <h4 className="sectionTitle">Slack Workspace </h4>
                            <span className={styles.textwork}>By Worktual</span>
                            <p className={styles.textscontent}>Connect and interact with your  teams instantly via Worktual Call and Meeting from within Slack</p>
                            <div className={styles.button}>
                                <button className={styles.btn} onClick={SlackAuth}>Add To Slack</button>
                                <button onClick={()=>{window.open('https://www.worktual.co.uk/help/')}} className={styles.btns}>Support</button>
                            </div>
                        </div>
                    </div>
                    <Slider {...settings} className="testimonialCarousel customeArrow dotarrowsbtmwhite comtopmunet abc">
                        <div className="slideItem">
                            <div className={styles.newSection}>
                                {/* <div className={styles.leftSection}>
                                        <h4>Group Calling</h4>
                                        <p>No more us and them. Combine calls with external numbers and internal extensions with zero fuss</p>
                                    </div> */}
                                <div className={styles.imageSection}>
                                    <img src={Image1} alt="" className={styles.imageSectionssss} />
                                </div>
                            </div>
                            {/* <h2 className="slideItemTitle">Easy setup</h2>
                                    <p className="slideItemDesc">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliquat enim ad minim.</p> */}
                        </div>
                        <div className="slideItem">
                            <div className={styles.newSection}>
                                {/* <div className={`${styles.leftSection} ${styles.collaboratebg}`}>

                                        <h4>Call Flip</h4>
                                        <p>Heading off doesn’t have to mean hanging up. Simply move your call to your mobile device and keep the conversation going</p>
                                    </div> */}
                                <div className={`${styles.imageSection} ${styles.meetimgradius}`}>
                                    <img src={Image3} alt="" className={styles.imageSectionssss} />
                                </div>
                            </div>
                            {/* <h2 className="slideItemTitle">Easy setup</h2>
                                    <p className="slideItemDesc">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliquat enim ad minim.</p> */}
                        </div>
                        <div className="slideItem">
                            <div className={styles.newSection}>
                                {/* <div className={`${styles.leftSection} ${styles.meetbg}`}>

                                        <h4>Call Recording and Transcription</h4>
                                        <p>“Who was I to follow up with?”
                                            With state-of-the-art speech-to-text you can double-check conversations by revisiting the auto-generated written record</p>
                                    </div> */}
                                <div className={`${styles.imageSection} ${styles.meetimgradius}`}>
                                    <img src={Image2} alt="" className={styles.imageSectionssss} />
                                </div>
                            </div>
                            {/* <h2 className="slideItemTitle">Easy setup</h2>
                                    <p className="slideItemDesc">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliquat enim ad minim.</p> */}
                        </div>
                    </Slider>



                </div>
                <div className={`${styles.decription} ${styles.containers}`}>
                    <div className={styles.maindescrsec}>
                        <h2>Description</h2>
                        <p>Seamlessly integrate the Worktual services with Slack for enabling the team to communicate and collaborate internally Instantly connect with co-workers through Worktual video meeting or voice call using bot commands from the Slack’s channel or direct messages.</p>
                        <p>This integration streamlines business communications within an organization, without switching between two applications, thereby increasing productivity of the team.</p>
                    </div>
                    <div className={styles.maindescrseclist}>
                        <h2>Key Features</h2>
                        <ul>
                            <li><span className={styles.circlegreen}></span>Initiate instant Worktual meeting and voice call quickly by using bot commands (such as /worktual start, /worktual call, /worktual help, /worktual login)</li>
                            <li><span className={styles.circlegreen}></span>Start a Worktual meeting with a button-click </li>
                            <li><span className={styles.circlegreen}></span>Easy Conference scheduling - Create and share the conference bridge details quickly via bot commands</li>
                        </ul>

                    </div>
                    <div className={styles.maindescrseclist}>
                        <h2>Benefits</h2>
                        <ul>
                            <li><span className={styles.circlegreen}></span>The seamless integration reduces the need for users to switch between applications and helps the teams to progress faster, thus improving the productivity of the teams</li>
                            <li><span className={styles.circlegreen}></span>Connecting Slack with the business applications automates your daily chores, which in turn increase the work efficiency.</li>
                        </ul>
                    </div>
                    <div className={styles.maindescrseclist}>
                        <h2>Requirements</h2>
                        <ul>
                            <li><span className={styles.circlegreen}></span>Must have an active Slack account</li>
                            <li><span className={styles.circlegreen}></span>Must have an active Worktual account</li>
                            <li className={styles.marbtm}><span className={styles.circlegreen}></span>Must have subscribed for the Growth or Enterprise business plan that includes third-party integrations</li>
                        </ul>
                    </div>
                </div>
            </div>
            <GetStarted />
            <Footer />
        </>
    )
}
export { SlackPage }